import { useMemo } from 'react';
import { useRouter } from 'next/router';

import { Text } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../../hooks/queries/properties';

import PropertyConstants from '../../../../constants/PropertyConstants';
import NetworkView from '../../../OverviewPage/modules/Listing/NetworkView';

const { SYNDICATION_OVERVIEW_STATUS } = PropertyConstants;

const LearnMore = () => {
  const router = useRouter();
  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const { isMultifamily, syndication } = listingDetails ?? {};

  const syndicationOverviewStatus = syndication?.overview?.status;
  const realtorUrl = syndication?.realtor?.url;
  const rentUrl = syndication?.rent?.url;
  const redfinUrl = syndication?.redfin?.url;
  const apartmentGuideUrl = syndication?.apartmentGuide?.url;

  const possiblePublishSites = useMemo(() => {
    /**
     * ["zillow", "trulia", "hotpads", "realtor", "rent", "apartmentGuide", "redfin"] if MF,
     * else ["zillow", "trulia", "hotpads"]
     **/
    let possiblePublishSitesState = 3;

    if (isMultifamily) {
      possiblePublishSitesState =
        possiblePublishSitesState +
        (realtorUrl ? 1 : 0) +
        (rentUrl ? 1 : 0) +
        (apartmentGuideUrl ? 1 : 0) +
        (redfinUrl ? 1 : 0);
    }

    return possiblePublishSitesState;
  }, [isMultifamily, realtorUrl, rentUrl, apartmentGuideUrl, redfinUrl]);

  const renderPublishText = () => {
    if (syndicationOverviewStatus === SYNDICATION_OVERVIEW_STATUS.PUBLISHED) {
      return 'View on Zillow Rental Network';
    }
    if (syndicationOverviewStatus === SYNDICATION_OVERVIEW_STATUS.PUBLISHING) {
      return `Published to ${syndication?.overview?.publishedCount} of ${possiblePublishSites} sites...`;
    }

    if (syndicationOverviewStatus === SYNDICATION_OVERVIEW_STATUS.INACTIVE) {
      return 'Publish to the Zillow Rental Network';
    }

    return null;
  };

  return (
    <>
      {syndicationOverviewStatus === SYNDICATION_OVERVIEW_STATUS.PUBLISHED ||
      syndicationOverviewStatus === SYNDICATION_OVERVIEW_STATUS.PUBLISHING ? (
        <NetworkView syndication={syndication} label={renderPublishText()} />
      ) : (
        <Text
          css={{
            textStyle: { base: 'body-xs', lg: 'body-sm-bold', xl: 'body' },
          }}
          data-testid="LearnMore-Text"
        >
          {renderPublishText()}
        </Text>
      )}
    </>
  );
};

export default LearnMore;
